import { ICol } from "../../../../interfaces";

/**
 * Calculate the maximum depth of a header structure.
 *
 * @param headers - An array of header objects defining the table structure.
 * @returns The maximum depth of the header structure.
 */
export const calculateHeaderDepth = (headers: ICol[]): number => {
  let maxDepth = 1;

  for (const header of headers) {
    if (header.cols && header.cols.length > 0) {
      const subDepth = 1 + calculateHeaderDepth(header.cols);
      maxDepth = Math.max(maxDepth, subDepth);
    }
  }

  return maxDepth;
};

/**
 * Count the total leaf columns in a nested structure.
 * Space cells count as 1 column width.
 *
 * @param headers - An array of header objects defining the table structure.
 * @returns The total number of leaf columns in the header structure.
 */
export const countLeafColumns = (headers: ICol[]): number => {
  let count = 0;

  for (const header of headers) {
    if (header.type === "space") {
      count += 1; // Space always counts as 1 column
    } else if (header.cols && header.cols.length > 0) {
      count += countLeafColumns(header.cols);
    } else {
      count += 1;
    }
  }

  return count;
};
